import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import { getToken } from '../../lib';
import RoomRecordingsTable from '../../components/RoomRecordingsTable/Table';
import { FormattedMessage } from 'react-intl';
import { RaisedButton } from 'material-ui';

class RoomRecordings extends Component {
  componentDidMount() {
    const token = getToken();
    this.props.fetchRoomRecordings(token);
  }

  handleDeleteTouch = (e, message, id) => {
    const token = getToken();
    this.setState({
      singleIconClick: true,
      selectedRows: [],
      snackbarOpen: true,
      snackbarMessage: message
    });
    e.target.style.fill = e.target.style.fill === 'red' ? '#afb8c5' : 'red';
    this.props.deleteRoomRecording(token, id);
  };

  render() {
    return (
      <div>
        <Paper className="pa3" style={{textAlign:"center"}}>
          {/* <div style={{ textAlign: 'left'}}>
            <RaisedButton
              onClick={() => {
                sessionStorage.clear();
                this.props.history.push({
                  pathname: '/admin/transcriptions'})
              }}
              backgroundColor="#60d1bd"
              labelStyle={{ color: "#fff" }}
              className="transcription-search-button"
              label={<FormattedMessage id="roomRecordings.recordingTranscriptionSearch" />}
              style={{ height: 42, margin: "10px 0", minWidth: '180px' }}
            />
          </div> */}
          <RoomRecordingsTable
            {...this.props}
            handleDeleteTouch={this.handleDeleteTouch}
          />
        </Paper>
      </div>
    );
  }
}

export default RoomRecordings;


// WEBPACK FOOTER //
// src/routes/RoomRecordings/RoomRecordings.js